export default __webpack_public_path__ + "img/0242d1d1b56cb3c5f84ad21ec8af44bb.svg";